export default {
  base: {
    listStyle: 'none',
    padding: 0,
    margin: 0,
    variant: 'spark.base.wrapper'
  },
  variants: {
    withDivider: {
      variant: 'spark.element.list.base',
      li: {
        borderTopStyle: 'solid',
        borderColor: 'grey-50',
        borderTopWidth: 1,
        ':last-of-type': {
          borderBottomWidth: 1,
          borderBottomStyle: 'solid'
        }
      }
    }
  },
  item: {
    base: {
      display: 'flex',
      alignItems: 'baseline',
      py: 20,
      header: {
        display: 'block',
        mb: 8
      }
    },
    variants: {
      withTitle: {
        variant: 'spark.element.list.item.base',
        alignItems: 'baseline',
        svg: {
          transform: 'translateY(2px)'
        }
      }
    }
  },
  icon: {
    base: {
      mr: 20,
      transform: 'translateY(2px)',
      display: 'flex',
      alignItems: 'center'
    }
  }
};